import { IUpdateSettings } from "@/api/AppApi/services/auth/interfaces/IAuth";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { DeliveryMethodsTypes } from "@/api/AppApi/services/company/interfaces/ICompany";
import SvgEdit from "@/app/components/common-builder/pop-ups-components/pop-up-helpers/SvgEdit";
import SvgLocation from "@/app/components/common-builder/pop-ups-components/pop-up-helpers/SvgLocation";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import { Col, Row } from "@/app/components/lib/my-bootstrap";
import SvgDelivery from "@/app/components/pages-components/checkout/checkout-icons/SvgDelivery";
import SvgPickup from "@/app/components/pages-components/checkout/checkout-icons/SvgPickup";
import { useTranslation } from "@/hooks/localization/useTranslations";
import {
  getPCAppHorPadding,
  getPCMaxAppWidth,
} from "@/utils/functions/global-constants";
import React from "react";

interface Props {
  top: number;
  handleDrawerOpen: () => void;
  mobile: boolean;
  settings: IUpdateSettings;
}
const DeliveryNavpar: React.FC<Props> = ({
  top,
  handleDrawerOpen,
  mobile,
  settings,
}) => {
  const t = useTranslation();

  const getCompany = useGetCompanyQuery();
  const company = getCompany?.data?.result;
  const isStandardWidth = company?.theme?.components?.body
    ?.layout_standard_width as boolean;

  const { address_name, country_name } = settings?.delivery_address_obj ?? {};
  const {
    delivery_time,
    pickup_time,
    receiving_type,
    pickup_branch_obj,
    delivery_time_type,
    pickup_time_type,
  } = settings ?? {};
  const receivingTime =
    receiving_type === DeliveryMethodsTypes.delivery
      ? delivery_time
      : pickup_time;
  const receivingTimeType =
    receiving_type === DeliveryMethodsTypes.delivery
      ? delivery_time_type
      : pickup_time_type;
  const receivingBranch = pickup_branch_obj?.name;
  return (
    <nav
      className="delivery-header nav-bar w-100"
      style={{ position: "fixed", top: top }}
      onClick={handleDrawerOpen}
    >
      <Row
        className="flex-nowrap align-items-center justify-content-center p-0 my-2"
        style={{
          width: getPCMaxAppWidth(isStandardWidth),
          maxWidth: "100%",
          padding: `0 ${getPCAppHorPadding(isStandardWidth)}px`,
          margin: "auto",
        }}
      >
          <Col
          className={`p-0 col-1 d-flex `}
          style={{ gap: 16 }}
        >
          <CustomButton
            type={mobile ? BtnTypes.semi_small_no_border : BtnTypes.semi_small}
            size={BtnSizes.semi_small}
            radius={BtnRadius.semi_small}
            onClick={handleDrawerOpen}
          >
            <SvgEdit />
            {!mobile && <div>{t.change}</div>}
          </CustomButton>
        </Col>
        <Col className={"p-0 text-center center col-11"}>
          {receiving_type && (
            <div className={`curr-address ${mobile ? "flex-column" : ""}`}>
              <div className="address-item ">
                <>
                  {receiving_type === DeliveryMethodsTypes.delivery ? (
                    <SvgDelivery mobile={false} primary />
                  ) : (
                    <SvgPickup isPrimaryColor mobile={false} />
                  )}
                </>
                <div>
                  {t[receiving_type]} |
                  {receivingTimeType === "now" ? t.now : receivingTime}
                </div>
              </div>
              <div className="address-item ">
                <SvgLocation />
                <div>
                  {receiving_type === DeliveryMethodsTypes.delivery ? (
                    <>
                      {address_name}({country_name})
                    </>
                  ) : (
                    <>{receivingBranch}</>
                  )}
                </div>
              </div>
            </div>
          )}
        </Col>
      
      </Row>
    </nav>
  );
};

export default DeliveryNavpar;
